import { useSuspenseQuery } from '@tanstack/react-query';
import type { AdsHistory } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import type { ListResponse, SortingParams } from 'types/shared';
import { apiClient } from 'lib/api';

interface GetAdsHistoryParams extends Partial<SortingParams> {
  name?: string;
  pack_id?: number[];
  status?: boolean;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
}

export const getAdsHistory = async (
  params?: GetAdsHistoryParams,
  signal?: AbortSignal
): Promise<ListResponse<AdsHistory>> => {
  const res = await apiClient.get<ListResponse<AdsHistory>>(
    queryKeys.adsHistory,
    {
      signal,
      params,
    }
  );
  return res.data;
};

interface UseAdsHistoryOptions<TData> {
  config?: QueryConfig<typeof getAdsHistory, TData>;
  params?: GetAdsHistoryParams;
}

export const useAdsHistory = <TData = ListResponse<AdsHistory>>({
  config,
  params,
}: UseAdsHistoryOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getAdsHistory(params, signal),
    queryKey: [
      queryKeys.adsHistory,
      params?.name,
      params?.status,
      params?.start_date,
      params?.end_date,
      params?.desc,
      params?.order_by,
      params?.offset,
      params?.limit,
    ],
  });
};
